import '@fontsource/archivo/700.css'
import '@fontsource/archivo/800.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import './styles.css'

const container = document.getElementById('root')
if (!container) throw new Error('No #root element')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
